export default class BidModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
